const { default: axios } = require('axios')

export const endDelegateChat = async (payload) => {
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    // eslint-disable-next-line camelcase
    url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_NORTH_EAST_URL}/doctorDashboard-endDelegateChat`,
    mode: 'cors',
    data: JSON.stringify(payload),
  }
  await axios(config)
  return true
}
